import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/fonts.css';
import './src/styles/tailwind.css';

export const shouldUpdateScroll = ({ routerProps }) => {
  return false;
};
